const getDefaultState = () => ({
  idFlux: '',
  executionCode: '',
  fnolMavalueReportComponent: '',
  damagesConfirmed: false
})

export {
  getDefaultState
}
